import React, { useCallback, useMemo } from 'react'
import ActivitiesComponent from 'components/Activities'
import Activity from './Activity'
import { useBoardContext } from 'dataProviders/Board'
import { useSelector, useDispatch } from 'react-redux'
import { createSelector, createStructuredSelector } from 'reselect'
import { currentUserSelector } from 'selectors/currentUser'
import fetchActivities from '../sagas/fetchActivities'
import { sagaActions as rootSagaActions } from 'store/sagas'

type StateProps = {
  isLoaded: boolean
  isLoading: boolean
  lastLoadedId?: number
  currentUser: any
  activities: any[]
  activitiesDetailLevel: number
}

type Props = {
  focusActivity?: number
}

const Activities: React.FC<Props> = ({
  focusActivity,
}) => {
  const boardContext = useBoardContext()

  const selector = useMemo(() => createStructuredSelector<any, StateProps>({
    isLoaded: state => state['view-board'].activities[boardContext.id].isLoaded,
    isLoading: state => state['view-board'].activities[boardContext.id].isLoading,
    lastLoadedId: state => state['view-board'].activities[boardContext.id].lastLoadedId,
    currentUser: currentUserSelector,
    activities: createSelector(
      [
        state => state['view-board'].activities[boardContext.id].activities,
        state => state['view-board'].activities[boardContext.id].activitiesById,
      ],
      (activities, activitiesById) => activities.map(id => activitiesById[id])
    ),
    activitiesDetailLevel: state => state.kanbo.currentUser.settings.activitiesDetailLevel,
  }), [boardContext])

  

  const {
    isLoaded,
    isLoading,
    lastLoadedId,
    currentUser,
    activities,
    activitiesDetailLevel,
  } = useSelector<any, StateProps>(selector)

  const dispatch = useDispatch()

  const dispatchFetchActivities = useCallback(
    () => dispatch(fetchActivities({
      boardId: boardContext.id
    })),
    [dispatch, boardContext]
  )

  const requestChangeUserSettings = useCallback(
    (...args) => dispatch(rootSagaActions.requestChangeUserSettings(...args)),
    [dispatch]
  )

  const handleDetailLevelChange = useCallback((detailLevel) => {
    requestChangeUserSettings({
      activitiesDetailLevel: detailLevel
    })
  }, [requestChangeUserSettings])

  return (
    <ActivitiesComponent
      context={`board-${boardContext.id}`}
      isLoaded={isLoaded}
      isLoading={isLoading}
      lastLoadedId={lastLoadedId}
      currentUser={currentUser}
      detailLevel={activitiesDetailLevel}
      activities={activities}
      activityComponent={Activity}
      focusActivity={focusActivity}
      fetchActivities={dispatchFetchActivities}
      onDetailLevelChange={handleDetailLevelChange}
    />
  )
}

export default Activities
